var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatFilledIcon = function SvgChatFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "chat filled icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.75a.74.74 0 0 1-.53-.22l-1.78-1.78H8a.76.76 0 0 1-.5-.22l-2.81-2.78H3.5a2.28 2.28 0 0 1-2.25-2.25v-8A2.28 2.28 0 0 1 3.5 3.25h14a2.28 2.28 0 0 1 2.25 2.25v1.75h.75a2.28 2.28 0 0 1 2.25 2.25v7a2.28 2.28 0 0 1-2.25 2.25h-1.19l-1.78 1.78a.74.74 0 0 1-.53.22Zm-7.19-3.5H15c.199 0 .39.08.53.22L17 18.94l1.47-1.47a.75.75 0 0 1 .53-.22h1.5a.78.78 0 0 0 .75-.75v-7a.78.78 0 0 0-.75-.75h-.75v4.75a2.28 2.28 0 0 1-2.25 2.25h-6.19l-1.5 1.5ZM3.5 4.75a.78.78 0 0 0-.75.75v8a.78.78 0 0 0 .75.75H5c.199 0 .39.08.53.22L8 16.94l2.47-2.47a.75.75 0 0 1 .53-.22h6.5a.78.78 0 0 0 .75-.75v-8a.78.78 0 0 0-.75-.75h-14Z",
    fill: "#007081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4h14A1.54 1.54 0 0 1 19 5.5v8a1.54 1.54 0 0 1-1.5 1.5H11l-3 3-3-3H3.5A1.54 1.54 0 0 1 2 13.5v-8A1.54 1.54 0 0 1 3.5 4ZM7 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "#007081"
  })));
};
export default SvgChatFilledIcon;